import { createContext } from "react";

interface ChartDataActionsContextProps {
  deleteMeasureById({ id }: { id: string }): void;
}

const ChartDataActionsContext = createContext<ChartDataActionsContextProps | undefined>(undefined);

export default ChartDataActionsContext;
